import { FundingData } from '../types';
import { composeExternalUrl } from '../../marketplace/utils';
import { fundingConfig } from '../../commons/config';
import moment from 'moment';
import { shortAmount } from '../../commons/utils';
import { useCurrentUser } from '../../user/hooks/useCurrentUser';

export const useFundingConsultationLink = (
  funding: FundingData | null | undefined
): string | null => {
  const user = useCurrentUser();

  if (!funding || !user) return null;

  return composeExternalUrl(
    { type: 'calendly', baseUrl: fundingConfig.fundingConsultationUrl },
    user,
    {
      a1: funding.personalCreditScore ? `${funding.personalCreditScore}` : '',
      a2:
        funding.businessStartMonth && funding.businessStartYear
          ? moment(new Date(funding.businessStartYear, funding.businessStartMonth + 1, 1)).format(
              'MMMM YYYY'
            )
          : '',
      a3: shortAmount(funding.sumOfLoanCustomerNeeds) ?? '',
    }
  );
};
